<template>
  <ManageFilters />
  <div v-auto-animate>
    <ProductFilter
      v-for="filter of productStore.filters"
      :key="filter.name"
      :filter="filter"
    />
  </div>
</template>

<script setup lang="ts">
import ProductFilter from '@/pages/CategoryPage/Partials/Filters/ProductFilter.vue';
import ManageFilters from '@/pages/CategoryPage/Partials/ManageFilters.vue';
import { useAlgoliaProductStore } from '@/stores/Category/AlgoliaProductStore';

const productStore = useAlgoliaProductStore();
</script>
